export default __webpack_public_path__ + "static/complete-1m-d9293b5880cc9b0ce8e36480dc79d808.webp";